import { useEffect } from "react";

// Jenkins supplies this at React build time. Do not manually edit a version number.
const CURRENT_VERSION = process.env.REACT_APP_BUILD_VERSION;
const INTERVAL_MS = 30000;

// Local React development must not poll the deployed version endpoint.
const isLocalhost = () => ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);

export default function useDeploymentVersion() {
  useEffect(() => {
    if (isLocalhost() || !CURRENT_VERSION) return;
    let reloading = false;
    let inFlight = false;
    const check = async () => {
      if (reloading || inFlight) return;
      inFlight = true;
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: "no-store", credentials: "same-origin",
          headers: { Accept: "application/json" },
        });
        if (!response.ok || !(response.headers.get("content-type") || "").includes("application/json")) return;
        const data = await response.json();
        if (typeof data.version === "string" && data.version && data.version !== CURRENT_VERSION) {
          reloading = true;
          window.location.reload();
        }
      } catch (e) {
        // Deployment may be in progress; retry on the next interval.
        console.warn("배포 버전 확인 실패", e);
      } finally { inFlight = false; }
    };
    const onFocus = () => { void check(); };
    const onVisible = () => { if (document.visibilityState === "visible") void check(); };
    const timer = window.setInterval(check, INTERVAL_MS);
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    void check();
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);
}
